import React, { useState } from "react";
import { motion } from "framer-motion";
import Questionmark from "../../svg/questionmark.svg";
import StepForm from "../form/StepForm";

const UnsureCard = ({ setUnsicher, scrollToIdElement, handleSaveFormData, guideFormGeneralData }) => {
  const [resultIndicator, setResultIndicator] = useState("");

  const handleResultIndicator = level => {
    setResultIndicator(level);
  };

  return (
    <article id="UnsicherId">
      <motion.div
        className="unsicher"
        initial={{ y: 30 }}
        animate={{ y: 0 }}
        exit={{ y: 30 }}
        transition={{ duration: 0.4 }}
      >
        <div className="unsureForm--chooserIcon">
          <Questionmark />
        </div>
        <div className="unsureForm--chooserIcon--background" />
        <div className={`card unsicher-wrapper ${resultIndicator}`}>
          <div className="unsureForm--header">
            <h1>{guideFormGeneralData.title}</h1>
          </div>
          <StepForm
            setUnsicher={setUnsicher}
            scrollToIdElement={scrollToIdElement}
            handleResultIndicator={handleResultIndicator}
            handleSaveFormData={handleSaveFormData}
            guideFormGeneralData={guideFormGeneralData}
          />
        </div>
      </motion.div>
    </article>
  );
};

export default UnsureCard;
